export default [
  {
    path: "/digests",
    name: "digestSearch",
    component: () =>
      import(/* webpackChunkName: "digests" */ "@/views/digests/Search.vue"),
    meta: {
      layout: "Split",
      requiresAuth: true,
      showBack: true
    }
  },
  {
    path: "/digests/generated/:id",
    name: "digestGeneratedPage",
    component: () =>
      import(/* webpackChunkName: "digests" */ "@/views/digests/DigestGenerated.vue"),
    meta: {
      layout: "Split",
      requiresAuth: true,
      showBack: true
    }
  },
  {
    path: "/digests/:id",
    name: "digestPage",
    component: () =>
      import(/* webpackChunkName: "digests" */ "@/views/digests/Digest.vue"),
    meta: {
      layout: "Split",
      requiresAuth: true,
      showBack: true
    }
  },
  // {
  //   path: "/digests-test/:id",
  //   name: "digestTest",
  //   component: () =>
  //     import(/* webpackChunkName: "digests" */ "@/views/digests/DigestTest.vue"),
  //   meta: {
  //     layout: "Split",
  //     requiresAuth: true,
  //     showBack: true
  //   }
  // }
];
